export default "__VITE_ASSET__Dfsi7PuN__"